<template>
  <v-card flat class="mt-4 pb-4">
    <v-card-actions
      class="pr-4"
      :class="$vuetify.breakpoint.smAndDown ? 'd-block' : ''"
    >
      <v-card-title primary-title>
        {{ $vuetify.lang.t('$vuetify.FLEETS.TITLE') }}
      </v-card-title>
      <v-spacer></v-spacer>
      <v-btn
        v-if="
          user &&
            (user.isAdmin ||
              (user.isPlaceAdmin && !user.isFleetManager) ||
              isGlobalAdmin ||
              user.isPlaceAdmin)
        "
        color="success"
        text
        small
        @click.stop="openEditFleetDialog()"
      >
        <v-icon class="mr-2">mdi-plus</v-icon>
        {{ $vuetify.lang.t('$vuetify.FLEETS.ADD_NEW') }}
      </v-btn>
      <v-btn
        v-if="user.managesVisitorsForFleetUser"
        color="success"
        :class="$vuetify.breakpoint.smAndDown ? 'ml-2' : ''"
        text
        small
        @click.stop="
          openStartSessionDialog(
            user.managesVisitorsForFleetUser.fleetUserId,
            user.managesVisitorsForFleetUser.fleetId
          )
        "
      >
        <v-icon class="mr-2">mdi-plus</v-icon>
        {{ $vuetify.lang.t('$vuetify.DASHBOARD.START_SESSION') }}
      </v-btn>
    </v-card-actions>
    <v-expansion-panels
      v-if="fleets.length || loading.type == 'getFleetActiveSessions'"
      v-model="panel"
      :value="panel"
      :accordion="false"
      :popout="true"
      :inset="false"
      :multiple="false"
      :focusable="false"
      :disabled="false"
      :readonly="false"
      :flat="false"
      :hover="false"
      :tile="true"
    >
      <v-expansion-panel v-for="fleet in fleets" :key="fleet.Id">
        <v-expansion-panel-header
          :class="$vuetify.breakpoint.smAndDown ? 'd-block' : ''"
          @click="getFleetSessions(fleet.Id)"
        >
          {{ fleet.Name }}
          <div class="d-flex text-right mr-3 justify-end">
            <div
              style="max-width: 68px;"
              class="justify-end"
              :class="$vuetify.breakpoint.smAndDown ? 'ml-auto mt-3' : ''"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-if="
                      user &&
                        (user.isFleetManager ||
                          user.isAdmin ||
                          user.isPlaceAdmin ||
                          isGlobalAdmin)
                    "
                    icon
                    color="secondary"
                    small
                    class="text-right mr-3"
                    outlined
                    v-on="on"
                    @click.stop="
                      openFleetUsersDialog(fleet.Id > 0 ? fleet.Id : '')
                    "
                  >
                    <v-icon small>mdi-account</v-icon>
                  </v-btn>
                </template>
                <span>
                  {{ $vuetify.lang.t('$vuetify.EDIT_WHITELISTS.USERS') }}
                </span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-if="
                      user &&
                        (user.isAdmin ||
                          (user.isPlaceAdmin && !user.isFleetManager) ||
                          isGlobalAdmin ||
                          user.isPlaceAdmin)
                    "
                    icon
                    color="primary"
                    small
                    outlined
                    v-on="on"
                    @click.stop="openEditFleetDialog(fleet.Id)"
                  >
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>
                  {{ $vuetify.lang.t('$vuetify.EDIT') }}
                </span>
              </v-tooltip>
            </div>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-simple-table class="overflow-y-auto" style="max-height: 60vh;">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="secondary--text darken">
                    {{ $vuetify.lang.t('$vuetify.LOCATION') }}
                  </th>
                  <th class="secondary--text darken">
                    {{ $vuetify.lang.t('$vuetify.CAR_NUMBER') }}
                  </th>
                  <th class="secondary--text darken">
                    {{ $vuetify.lang.t('$vuetify.START_TIME') }}
                  </th>
                  <th class="secondary--text darken">
                    {{ $vuetify.lang.t('$vuetify.END_TIME') }}
                  </th>
                  <th></th>
                  <!-- <th class="secondary--text darken">
                    {{ $vuetify.lang.t('$vuetify.COST') }}
                  </th>
                  <th class="secondary--text darken">
                    {{
                      $vuetify.lang.t('$vuetify.FLEET_REPORT.USED_FLEET_CREDIT')
                    }}
                  </th>
                  <th class="secondary--text darken">
                    {{ $vuetify.lang.t('$vuetify.FLEET_REPORT.SELF_PAID') }}
                  </th> -->
                </tr>
              </thead>
              <tbody v-if="availabilityInfo">
                <tr
                  v-for="sess in computedSessions"
                  :key="sess.ParkingSessionId"
                >
                  <td>{{ sess.PlaceAddress }}</td>
                  <td>{{ sess.CarNumber }}</td>
                  <td>{{ dateEE(sess.StartTime) }}</td>
                  <td>{{ dateEE(sess.EndTime) }}</td>
                  <td>
                    <v-menu offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn color="primary" small v-bind="attrs" v-on="on">
                          {{ $vuetify.lang.t('$vuetify.EXTEND_TIME') }}
                        </v-btn>
                      </template>
                      <v-list dense>
                        <v-list-item
                          v-for="item in [
                            0,
                            1,
                            2,
                            3,
                            4,
                            5,
                            6,
                            7,
                            8,
                            9,
                            10,
                            11,
                            12
                          ]"
                          :key="item"
                          @click="extendSessionTime(sess, item)"
                        >
                          <v-list-item-title>{{ item }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </td>
                  <!-- <td>{{ sess.TotalCostInCents / 100 }}</td>
                  <td>
                    {{ sess.UsedFleetCreditCents / 100 }}
                  </td>
                  <td>{{ sess.SelfPaidCents / 100 }}</td> -->
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-col
            v-if="!computedSessions.length && !loading.state"
            transition="fade-transition"
            cols="12"
            class="d-flex align-center justify-center body-2 text--secondary"
          >
            {{ $vuetify.lang.t('$vuetify.EDIT_WHITELISTS.NO_ACTIVE_SESSIONS') }}
          </v-col>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <start-fleet-session-dialog
        v-if="clickedFleetUserId"
        :fleet-id="currentFleetId"
        :fleet-user-id="clickedFleetUserId"
        :visible="startSessionDialog"
        @close="closeStartSessionDialog()"
      />
      <fleet-users
        :title="currentFleetId > 0 ? 'Edit user' : 'Add user'"
        :visible="fleetUsersDialog"
        @close="fleetUsersDialog = false"
      />
    </v-expansion-panels>
    <v-row v-else>
      <v-col cols="12" class="d-flex justify-center">
        <empty-state-card
          v-if="fleetsLoaded && !fleets.length && !loading.state"
          :title="$vuetify.lang.t('$vuetify.EMPTY_STATE.FLEETS_EMPTY_HERE')"
          color="transparent"
          :message="
            $store.state.app.vehicleNumberSearchString
              ? $vuetify.lang.t(
                  '$vuetify.EMPTY_STATE.FLEETS_VEHICLE_NUMBER_SEARCH_NO_RESULTS'
                )
              : $vuetify.lang.t(
                  '$vuetify.EMPTY_STATE.FLEETS_EMPTY_HERE_MESSAGE'
                )
          "
          class="empty-state"
        />
        <v-toolbar v-else class="elevation-0">
          <v-spacer></v-spacer>
          <v-progress-circular
            indeterminate
            color="secondary"
          ></v-progress-circular>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-col>
    </v-row>
    <edit-fleet-dialog
      :title="currentFleetId > 0 ? 'Edit fleet' : 'Add fleet'"
      :visible="editFleetDialog"
      @close="editFleetDialog = false"
    />
  </v-card>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import formatDate from '@/mixins/formatDate'

export default {
  name: 'FleetSessions',
  components: {
    StartFleetSessionDialog: () =>
      import(
        /* webpackChunkName: "StartFleetSessionDialog" */ '@/components/StartFleetSessionDialog'
      ),
    EmptyStateCard: () =>
      import(
        /* webpackChunkName: "EmptyStateCard" */ '@/components/commonComponents/EmptyStateCard'
      ),
    EditFleetDialog: () =>
      import(
        /* webpackChunkName: "EditFleetDialog" */ '@/components/fleets/EditFleetDialog'
      ),
    FleetUsers: () =>
      import(
        /* webpackChunkName: "FleetUsers" */ '@/components/fleets/FleetUsers'
      )
  },
  mixins: [formatDate],
  data() {
    return {
      headers: [
        {
          text: 'Phone number',
          align: 'start',
          sortable: false,
          value: 'PhoneNumber'
        },
        { text: 'Licence Plate', value: 'CarNumber' },
        { text: 'Name', value: 'Name' },
        { text: 'Email', value: 'Email' },
        { text: 'Daily Limit', value: 'DailyLimitInCents' },
        { text: 'Monthly Limit', value: 'MonthlyLimitInCents' },
        { text: 'Used Credit', value: 'UsedFleetCreditCents' },
        { text: 'Available Credit', value: 'AvailableCredit' },
        { text: 'Over Limit', value: 'SelfPaidCents' },

        { text: '', sortable: false, value: 'start-new-session' },
        { text: '', sortable: false, value: 'data-table-expand' }
      ],
      expanded: [],
      panel: null,
      startSessionDialog: false,
      clickedFleetUserId: null,
      editFleetDialog: false,
      fleetUsersDialog: false
    }
  },
  computed: {
    ...mapGetters('app', ['loading']),
    ...mapGetters('authentication', ['user', 'isGlobalAdmin']),
    ...mapGetters('fleets', [
      'fleets',
      'fleetsLoaded',
      'availabilityInfo',
      'currentFleetId'
    ]),
    fleetSessions() {
      const sessions = []
      if (this.availabilityInfo) {
        if (
          this.availabilityInfo.ReportRows &&
          this.availabilityInfo.ReportRows.length
        ) {
          this.availabilityInfo.ReportRows.forEach(row => {
            row.ParkingSessions.forEach(element => {
              sessions.push(element)
            })
          })
        }
      }
      return sessions
    },
    computedSessions() {
      return this.fleetSessions.filter(session => {
        return (
          this.isWithoutEndTime(session) ||
          this.isToday(session) ||
          this.isInTheFuture(session)
        )
      })
    }
  },
  async created() {
    if (!this.fleets || !this.fleets.length) {
      await this.getFleets().catch(() => {
        this.$store.dispatch('authentication/logout')
        this.$router.replace({ path: '/login' })
      })
    }
  },
  methods: {
    ...mapActions('fleets', [
      'getFleets',
      'getFleet',
      'getFleetUsers',
      'getFleetActiveSessions'
    ]),
    ...mapMutations('fleets', ['setCurrentFleetId', 'setAvailabilityInfo']),
    isWithoutEndTime(session) {
      return session.EndTime === '0001-01-01T00:00:00Z'
    },
    isToday(session) {
      const endTime = new Date(session.EndTime)
      const now = new Date()
      return (
        endTime.getDate() === now.getDate() &&
        endTime.getMonth() === now.getMonth() &&
        endTime.getFullYear() === now.getFullYear()
      )
    },
    isInTheFuture(session) {
      const today = new Date()

      // This line sets the time of the current date to the
      // last millisecond, so the comparison returns `true` only if
      // date is at least tomorrow
      today.setHours(23, 59, 59, 998)

      return new Date(session.EndTime) > today
    },
    appendLeadingZeroes(n) {
      if (n <= 9) {
        return `0${n}`
      }
      return n
    },
    openFleetUsersDialog(id) {
      this.getFleet(id).then(() => {
        this.getFleetUsers(id)
      })
      if (id !== this.currentFleetId) {
        this.setCurrentFleetId(id)
        this.panel = undefined
      }
      this.fleetUsersDialog = true
    },
    getFleetSessions(id) {
      this.setAvailabilityInfo([])
      this.setCurrentFleetId(id)
      this.getFleetActiveSessions({ fleetId: id })
    },
    openStartSessionDialog(userId, fleetId) {
      if (fleetId !== this.currentFleetId) {
        this.setCurrentFleetId(fleetId)
      }
      this.clickedFleetUserId = userId
      this.startSessionDialog = true
    },
    closeStartSessionDialog() {
      this.clickedFleetUserId = null
      this.startSessionDialog = false
    },
    openEditFleetDialog(id) {
      if (id && id !== this.currentFleetId) {
        this.setCurrentFleetId(id)
        this.panel = undefined
      }
      this.$router.push(`/fleet/${id || 0}`)
    },
    extendSessionTime(session, selectedHours) {
      this.$confirm(this.$vuetify.lang.t('$vuetify.CAN_NOT_BE_UNDONE'), {
        title: this.$vuetify.lang.t('$vuetify.ARE_YOU_SURE'),
        color: 'error',
        icon: 'mdi-alert',
        persistent: true,
        buttonTrueText: this.$vuetify.lang.t('$vuetify.YES'),
        buttonFalseText: this.$vuetify.lang.t('$vuetify.CANCEL')
      }).then(option => {
        if (option === true) {
          const currentEndTime = new Date(session.EndTime)
          const newEndTime = new Date(
            currentEndTime.setHours(currentEndTime.getHours() + selectedHours)
          )
          session.EndTime = newEndTime
          this.$store.dispatch('fleets/putSession', {
            this: this,
            sessionId: session.ParkingSessionId,
            fleetId: this.user.managesVisitorsForFleetUser.fleetId,
            fleetUserId: this.user.managesVisitorsForFleetUser.fleetUserId,
            placeId: session.PlaceId,
            carNumber: session.CarNumber,
            hours: selectedHours
          })
        }
      })
    }
  }
}
</script>
<style scoped>
::v-deep .v-data-table tbody tr.v-data-table__expanded__content {
  box-shadow: none !important;
}
@-webkit-keyframes flash {
  from {
    background-color: rgba(248, 192, 26, 0.3);
  }
  to {
    background-color: inherit;
  }
}
@-moz-keyframes flash {
  from {
    background-color: rgba(248, 192, 26, 0.3);
  }
  to {
    background-color: inherit;
  }
}
@-o-keyframes flash {
  from {
    background-color: rgba(248, 192, 26, 0.3);
  }
  to {
    background-color: inherit;
  }
}
@keyframes flash {
  from {
    background-color: rgba(248, 192, 26, 0.3);
  }
  to {
    background-color: inherit;
  }
}
.flash {
  -webkit-animation: flash 1s 1s; /* Safari 4+ */
  -moz-animation: flash 1s 1s; /* Fx 5+ */
  -o-animation: flash 1s 1s; /* Opera 12+ */
  animation: flash 1s 1s; /* IE 10+ */
}
</style>
